module.exports = __webpack_public_path__ + "img/logo.faaed6ee.png";